import { render, staticRenderFns } from "./RankList.vue?vue&type=template&id=15a99420"
import script from "./RankList.vue?vue&type=script&lang=js"
export * from "./RankList.vue?vue&type=script&lang=js"
import style0 from "./RankList.vue?vue&type=style&index=0&id=15a99420&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports